import { PhotoThumbnail } from '@components/common/PhotoThumbnail';
import { useMediaQueryContext } from '@fourthwall/components';
import React, { memo } from 'react';
import * as S from '../styled';
import { ItemStatus } from './ItemStatus';
export const OfferItemContent = memo(({ item, input, mode }) => {
    const media = useMediaQueryContext();
    return (React.createElement(React.Fragment, null,
        React.createElement(S.OpacityWrapper, null, input),
        React.createElement(S.OpacityWrapper, null,
            React.createElement(PhotoThumbnail, { url: item.image, size: media.tablet ? 'large' : 'small' })),
        React.createElement(S.ProductInfo, null,
            React.createElement(S.OpacityWrapper, null, item.name),
            React.createElement(S.Status, null, !media.tablet && React.createElement(ItemStatus, { item: item, mode: mode }))),
        media.tablet && React.createElement(ItemStatus, { item: item, mode: mode })));
});
